import React, { useState } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { toast } from "react-toastify";
import { createAssertionFromControlApi } from "../../../services/reference";
import { CreateAssertionInput } from "src/validation.ts/AssertionType";
import "./AddAccountType.css";




interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  addAccountType: (newAccountType: any) => void;
}

const CreateAccountType: React.FC<ModalProps> = ({ isOpen, onClose, addAccountType }) => {
  const [showErrors, setShowErrors] = useState(true);
  const [isLoadingButton, setLoadingButton] = useState(false);
  const {
    register: registerForm,
    handleSubmit,
    formState: { errors: errorsForm },
    reset: resetCreate
  } = useForm<CreateAssertionInput>();



  
  const onSubmit: SubmitHandler<CreateAssertionInput> = async (data) => {
    setLoadingButton(true);
    try {
      const responseData:any = await createAssertionFromControlApi(data);
      if (responseData.success) {
      
        toast("Account created successfully", { type: "success" });
        addAccountType(responseData.data);
        resetCreate();
       
        onClose();
      } else {
        toast("Failed to create account", { type: "error" });
      }
    } catch (error) {
      toast.error("Failed to create account");
    } finally {
      setLoadingButton(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-btn" onClick={onClose}>
          ×
        </button>
     

        <form onSubmit={handleSubmit(onSubmit)}>
          <section className="form-section">
            <div className="form-group">
              <label htmlFor="name" className="form-label">
                Account Name <span className="required-asterisk">*</span>
              </label>
              <input
                type="text"
                id="name"
                {...registerForm("name", { required: "You must include an Account name" })}
                className="form-control"
              />
              {showErrors && errorsForm.name && (
                <p className="error-message">{errorsForm.name.message}</p>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="description" className="form-label">
                Description 
              </label>
              <input
                type="text"
                {...registerForm("description")}
                id="description"
                className="form-control"
              />
              {showErrors && errorsForm.description && (
                <p className="error-message">{errorsForm.description.message}</p>
              )}
            </div>

            {/* Checkbox fields in a three-column grid */}
            <div className="checkbox-grid">
              {/* Checkbox field C */}
              <div className="checkbox-group">
                <label htmlFor="create_C" className="checkbox-label">C</label>
                <input
                  type="checkbox"
                  id="create_C"
                  {...registerForm("C")}
                  className="form-check-input"
                />
                {showErrors && errorsForm.C && (
                  <p className="error-message">{errorsForm.C.message}</p>
                )}
              </div>

              {/* Checkbox field E */}
              <div className="checkbox-group">
                <label htmlFor="create_E" className="checkbox-label">E</label>
                <input
                  type="checkbox"
                  id="create_E"
                  {...registerForm("E")}
                  className="form-check-input"
                />
                {showErrors && errorsForm.E && (
                  <p className="error-message">{errorsForm.E.message}</p>
                )}
              </div>

              {/* Checkbox field A */}
              <div className="checkbox-group">
                <label htmlFor="create_A" className="checkbox-label">A</label>
                <input
                  type="checkbox"
                  id="create_A"
                  {...registerForm("A")}
                  className="form-check-input"
                />
                {showErrors && errorsForm.A && (
                  <p className="error-message">{errorsForm.A.message}</p>
                )}
              </div>

              {/* Checkbox field V */}
              <div className="checkbox-group">
                <label htmlFor="create_V" className="checkbox-label">V</label>
                <input
                  type="checkbox"
                  id="create_V"
                  {...registerForm("V")}
                  className="form-check-input"
                />
                {showErrors && errorsForm.V && (
                  <p className="error-message">{errorsForm.V.message}</p>
                )}
              </div>

              {/* Checkbox field O */}
              <div className="checkbox-group">
                <label htmlFor="create_O" className="checkbox-label">O</label>
                <input
                  type="checkbox"
                  id="create_O"
                  {...registerForm("O")}
                  className="form-check-input"
                />
                {showErrors && errorsForm.O && (
                  <p className="error-message">{errorsForm.O.message}</p>
                )}
              </div>

              {/* Checkbox field P */}
              <div className="checkbox-group">
                <label htmlFor="create_P" className="checkbox-label">P</label>
                <input
                  type="checkbox"
                  id="create_P"
                  {...registerForm("P")}
                  className="form-check-input"
                />
                {showErrors && errorsForm.P && (
                  <p className="error-message">{errorsForm.P.message}</p>
                )}
              </div>
            </div>
          </section>
          
          <button
            type="submit"
            className="submit-button"
            disabled={isLoadingButton}
          >
            {isLoadingButton ? 'Loading...' : 'Submit'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateAccountType;
